// src/store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 这里可以定义你需要的状态，例如：
    FORM_TABLE_DATA: null,
    TABLE_DATA: null,
    USER_TYPE: null,
    IS_BANKRUPT_ADMIN: null
  },
  mutations: {
    setItem(state, { key, value }) {
      Vue.set(state, key, value)
    },
    removeItem(state, key) {
      Vue.delete(state, key)
    }
  },
  actions: {
    setItem({ commit }, payload) {
      commit('setItem', payload)
    },
    removeItem({ commit }, key) {
      commit('removeItem', key)
    }
  },
  getters: {
    getItem: (state) => (key) => {
      return state[key]
    }
  }
})